export const NATIVE_ROUTE_INTENT_QUERY_KEY = 'mpt_native_target';

const normalizeSearch = (search = '') => {
  const rawSearch = typeof search === 'string' ? search.trim() : '';
  return rawSearch.startsWith('?') ? rawSearch.slice(1) : rawSearch;
};

export function hasNativeRouteIntent(search = '') {
  return new URLSearchParams(normalizeSearch(search)).has(NATIVE_ROUTE_INTENT_QUERY_KEY);
}

export function buildPathWithoutNativeRouteIntent(pathname = '/', search = '') {
  const path = pathname || '/';
  const normalizedSearch = normalizeSearch(search);

  if (!normalizedSearch) {
    return path;
  }

  const params = new URLSearchParams(normalizedSearch);
  params.delete(NATIVE_ROUTE_INTENT_QUERY_KEY);

  const nextSearch = params.toString();
  return nextSearch ? `${path}?${nextSearch}` : path;
}
